import React from "react";
import { IoIosStar } from "react-icons/io";
import { FiUser } from "react-icons/fi";
import PrimaryBtn from "../../../utils/PrimaryBtn/PrimaryBtn";
import { Link, useNavigate } from "react-router-dom";

const Card = ({
  course_name,
  rating,
  _id,
  price,
  selectImage,
  discount_price,
  student_enrolled,
}) => {
  const navigate = useNavigate();

  let handleOverview = () => {
    navigate(`/overview?course_id=${_id}`);
  };


  // let GetConverted = toConvert(price);

  return (
    <div className="shadow-xl rounded-t-md">
      <div className="bg-white  text-center rounded-t-md relative overflow-hidden">
        <img className="w-full" src={selectImage} alt="img" />
      </div>
      <div className="px-4 py-5">
        <div className="flex justify-between gap-10 mb-3 max-sm:flex-col max-sm:gap-3">
          <h2 className=" text-textColor text-lg font-medium  max-sm:text-base ">
            {course_name}
          </h2>
          <p className="flex gap-2 items-center font-medium  text-textColor self-start mt-1">
            {rating} <IoIosStar className="text-[#E87C1E]" />
          </p>
        </div>
        <div className="text-[#4A4A4A] flex gap-2 items-center text-sm py-2">
          <FiUser className="text-xl -mt-[2px]" />
          <span>{student_enrolled} + Students Enrolled</span>
        </div>
        <div className="text-primary font-medium mt-1 mb-4">
          Rs.{price}{" "}
          <span className="line-through text-[#4A4A4A] ml-1 font-normal">
          ₹{discount_price}
          </span>
        </div>
        <button
          onClick={handleOverview}
          className="bg-primary rounded-md text-white font-normal  text-base  max-sm:text-sm py-[0.7rem] px-8 w-full">
          <Link to={"/overview"}>Grab Your Course</Link>
        </button>
      </div>
    </div>
  );
};

export default Card;
